import { capitalCase } from "change-case";
import { addMonths, addYears, format, isSameMonth, isSameYear, subMonths, subYears } from "date-fns";
import { useMemo } from "react";

import { faArrowLeft, faArrowRight } from "@fortawesome/pro-solid-svg-icons";
import ClearIconButton from "@ntemarked/mittne-components/dist/ClearIconButton/ClearIconButton";
import { Direction, Flex, Justify } from "@ntemarked/mittne-components/dist/Flex/Flex";

interface DatePickerProps {
	date: Date;
	setDate: (newDate: Date) => void;
	isFullYear: boolean;
}
export function DatePicker({ date, setDate, isFullYear }: Readonly<DatePickerProps>) {
	const { previous, next, dateFormat } = useMemo(() => {
		const previous = isFullYear ? subYears(date, 1) : subMonths(date, 1);
		const next = isFullYear ? addYears(date, 1) : addMonths(date, 1);
		const dateFormat = isFullYear ? "yyyy" : "MMMM yyyy";
		return { previous, next, dateFormat };
	}, [date, isFullYear]);

	return (
		<Flex direction={Direction.row} gap="0px" alignItems={Justify.center}>
			<ClearIconButton
				style={{ background: 0, padding: "20px 10px", border: 0 }}
				title={`Gå til ${format(previous, dateFormat)}`}
				onClick={() => setDate(previous)}
				icon={faArrowLeft}
				color="#28292C"
			/>
			<p style={{ minWidth: "150px", textAlign: "center", fontWeight: 500 }}>{capitalCase(format(date, dateFormat))}</p>
			<ClearIconButton
				style={{ background: 0, padding: "20px 10px", border: 0 }}
				title={`Gå til ${format(next, dateFormat)}`}
				onClick={() => setDate(next)}
				disabled={isFullYear ? isSameYear(date, new Date()) : isSameMonth(date, new Date())}
				icon={faArrowRight}
				color="#28292C"
			/>
		</Flex>
	);
}
